var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContentCopy = function SvgContentCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_7922",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_7922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54813 14.5833C7.12715 14.5833 6.77083 14.4375 6.47917 14.1458C6.1875 13.8541 6.04167 13.4978 6.04167 13.0769V3.58977C6.04167 3.1688 6.1875 2.81248 6.47917 2.52081C6.77083 2.22915 7.12715 2.08331 7.54813 2.08331H14.5352C14.9562 2.08331 15.3125 2.22915 15.6042 2.52081C15.8958 2.81248 16.0417 3.1688 16.0417 3.58977V13.0769C16.0417 13.4978 15.8958 13.8541 15.6042 14.1458C15.3125 14.4375 14.9562 14.5833 14.5352 14.5833H7.54813ZM7.54813 13.3333H14.5352C14.5994 13.3333 14.6581 13.3066 14.7115 13.2531C14.7649 13.1998 14.7917 13.141 14.7917 13.0769V3.58977C14.7917 3.5256 14.7649 3.46685 14.7115 3.41352C14.6581 3.36005 14.5994 3.33331 14.5352 3.33331H7.54813C7.48396 3.33331 7.42521 3.36005 7.37188 3.41352C7.3184 3.46685 7.29167 3.5256 7.29167 3.58977V13.0769C7.29167 13.141 7.3184 13.1998 7.37188 13.2531C7.42521 13.3066 7.48396 13.3333 7.54813 13.3333ZM4.63146 17.5C4.21049 17.5 3.85417 17.3541 3.5625 17.0625C3.27083 16.7708 3.125 16.4145 3.125 15.9935V5.25644H4.375V15.9935C4.375 16.0577 4.40174 16.1164 4.45521 16.1698C4.50854 16.2232 4.56729 16.25 4.63146 16.25H12.8685V17.5H4.63146Z",
    fill: "#152A58"
  }))));
};
export default SvgContentCopy;